import { Component, OnDestroy, OnInit, forwardRef, DoCheck, ChangeDetectorRef, Inject, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { ICardComponentInjectionToken } from '@infrastructure/ValidationMessages/ExternalValidationDirective';
//import { WorkflowComponent } from '../../../../workflow.component';
//import { CommonData } from '@infrastructure/CommonData/CommonDataResolver';
//import { DomainCodes } from '../../../../../../models/const.DomainCodes';
import { ModalService } from '@infrastructure/Modal/ModalService';
import { BeneficiaryListTableEditComponent } from '../../beneficiary-list-table-edit.component';
import { TableEditBase } from '@infrastructure/TableEdit/TableEditBase';
import { AsyncDataService } from '@infrastructure/AsyncData/AsyncDataService';
import { PreFilledProperty } from '@infrastructure/Models/pre-filled-property.interface';
//import { isNotNullOrUndefinedOrEmpty } from '@infrastructure/objectUtils';
import { DropdownsValues} from '@infrastructure/Dropdowns/const.dropdowns';
//import { BenefitChoosen } from '@infrastructure/Documents/benefit-choosen.enum';
import { BeneficiaryValuesService } from '@infrastructure/Beneficiaries/beneficiary-values.service';
import { LegalRepresentationStateService } from '@infrastructure/Beneficiaries/legal-representation-state.service';

@Component({
  selector: 'beneficiary-contacts',
  templateUrl: './beneficiary-contacts.component.html',
  providers: [
    {
      provide: ICardComponentInjectionToken,
      useExisting: forwardRef(() => BeneficiaryListTableEditComponent)
    }],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
  standalone: false
})

export class BeneficiaryContactsComponent extends TableEditBase<models.BeneficiaryVM> implements OnInit, OnDestroy {

  @Input("cardData")
  public cardData: models.BeneficiaryContactsVM = {} as models.BeneficiaryContactsVM;

/*  @Input() benefitChoosen: BenefitChoosen;*/
  @Input("hasLegalRepresentation")
  public hasLegalRepresentation: boolean;

  @Input("stateRL")
  public stateRL: number;


  @Input("personTypologyCode")
  public personTypologyCode: string;


  @Input("beneficiaryID")
  public beneficiaryID: number;

  @Input()
  public countries: models.DimensionVM[];

  public personTypesValues = DropdownsValues.dropDownPersonType;
  public preFilledProperties: PreFilledProperty[] = [];

  public mobilePattern: string = "^9\\d{8}$|^(?!\\+351\\s)(([+])(\\d{1,4})[\\\\ \\\\]\\d{1,12})$";
  public landlinePattern: string = "^(2|3)\\d{8}$|^(?!\\+351\\s)(([+])(\\d{1,4})[\\\\ \\\\]\\d{1,12})$";

  constructor(
    @Inject(BeneficiaryListTableEditComponent) public parent: Component,
    private modalService: ModalService,
    private asyncDataService: AsyncDataService,
    private beneficiaryValuesService: BeneficiaryValuesService,
    private beneficiariesStateService: LegalRepresentationStateService) {
    super(parent, modalService);
    
  }

  ngOnInit(): void {
    if (this.cardData) {
      const fieldArray = [
        "email",
        "mobileNumber",
        "countryCode",
        "address",
        "postalCodeFirst",
        "postalCodeLast",
        "postalCodeFull",
        "locality"
      ];
      this.preFilledProperties =
        this.beneficiaryValuesService
          .getPreFilledProperties(this.beneficiaryID, this.cardData, fieldArray);     
    }
  }





  ngOnDestroy(): void {
  }

  capitalize(value: string) {
    this.cardData[value] = this.cardData[value].toUpperCase();
  }

  public isFieldDisabled(name: string): boolean {
    let result = this.preFilledProperties.find(el => el.name == name).hasValue;
    return result;
  }

  onPostalCodeChanged() {
    if (this.cardData.postalCodeFirst?.length == 4 && this.cardData.postalCodeLast?.length == 3) {
      try {
        this.asyncDataService.getPostalCodeDesignation(this.cardData.postalCodeFirst, this.cardData.postalCodeLast).subscribe(designation => {
          this.cardData.postalDesignation = designation;
          this.cardData.postalCodeFull = this.cardData.postalCodeFirst + "-" + this.cardData.postalCodeLast;
           
        }, error => {
          console.log(error);
        });
      }
      catch (e) {
        console.log(e);
      }
    }
  }

  public isNotStateRLDiferido(): boolean {
    const result = this.beneficiariesStateService
      .getStateDeferido(this.hasLegalRepresentation, this.stateRL?.toString());
    return !result;
  }


  public isStateRLIndeferido(): boolean {
    const result = this.beneficiariesStateService
      .getStateIndeferido(this.hasLegalRepresentation, this.stateRL?.toString());
    return result;
  }
}
